// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"581":"33d66770","627":"63ec8de7"}[chunkId] + ".css";
};